module.exports = __webpack_public_path__ + "img/5.0edb2402.png";